import { render } from "./ChoiceCreationMode.vue?vue&type=template&id=14b1bafc&scoped=true&ts=true"
import script from "./ChoiceCreationMode.vue?vue&type=script&lang=ts"
export * from "./ChoiceCreationMode.vue?vue&type=script&lang=ts"

import "./ChoiceCreationMode.vue?vue&type=style&index=0&id=14b1bafc&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14b1bafc"]])

export default __exports__